import ToastNotification from '@components/ToastNotification';
import { AUTH_LOGIN_WELCOME_BACK, VERSION_LITE } from '@lib/constants';
import { useDispatch, useSelector } from 'react-redux';

import { useI18n } from '@lib/i18n';

const JustRegisteredToast = () => {
	const { justRegistered, user } = useSelector((state) => state.user);

	const { t } = useI18n();

	const dispatch = useDispatch();

	const hideJustRegistered = () => {
		dispatch({
			type: 'SET_JUST_REGISTERED',
			payload: false,
		});
	};

	return (
		!VERSION_LITE &&
		justRegistered && (
			<ToastNotification
				text={t('auth.login_welcome_back', AUTH_LOGIN_WELCOME_BACK) + ' ' + user.name}
				fadeOutTime={5000}
				removeToast={hideJustRegistered}
			/>
		)
	);
};
export default JustRegisteredToast;
